import { pathnameShouldNoIndex } from '../seo/noIndexRoutes';

/** Pages à token : signature sans compte. Une session périmée ne doit pas les quitter. */
const PUBLIC_SIGNATURE_PREFIXES = [
  '/cgv-accept/',
  '/documents/view/',
  '/carnet/',
  '/confirm-booking/',
  '/decline-booking/',
] as const;

export function isPublicSignaturePath(pathname: string): boolean {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  return PUBLIC_SIGNATURE_PREFIXES.some(prefix => p.startsWith(prefix));
}

/**
 * Sur les pages publiques indexables (blog, fiche pro, landings SEO)
 * et les pages de signature à token, un token expiré est ignoré
 * sans redirection vers /login.
 */
export function shouldRedirectToLoginOnSessionExpiry(pathname: string): boolean {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  if (isPublicSignaturePath(p)) return false;
  return pathnameShouldNoIndex(p);
}

/**
 * Retour header sans historique. null = rester sur la page de signature.
 */
export function emptyHistoryBackPath(pathname: string): '/' | null {
  return isPublicSignaturePath(pathname) ? null : '/';
}

/**
 * Cible `state.from` du login ouvert depuis le header.
 * Sur une signature, on revient sur le lien. L'accueil garde le compte.
 */
export function loginReturnFromPath(pathname: string, search = ''): string {
  const path = `${pathname || '/'}${search || ''}`;
  if (isPublicSignaturePath(pathname)) return path;
  if (!pathname || pathname === '/') return '/profile';
  return path;
}
